/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import React from 'react'
import { ICoverageDiscoveryResponseStateManager, IInpatientTypeInsurance } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'
import { InsuranceBenefitsComponent } from '../InsuranceBenefits/InsuranceBenefits'
import './BenefitInformation.scss'

export interface IBenefitInformationProps {
	CoverageDiscoveryResponseStateManager: ICoverageDiscoveryResponseStateManager
}

export class BenefitInformationComponent extends React.Component<IBenefitInformationProps> {
	render(): React.ReactNode {
		const section = this.props.CoverageDiscoveryResponseStateManager.selectedBenefitInformationSection
		if (!this.props.CoverageDiscoveryResponseStateManager.selectedBenefitInformationSection) return <></>
		else {
			const insurances = section.summary.insurances
			if (insurances && insurances.length > 0) {
				return (
					<table className="response-table service-types-table benefitinformation" style={{ width: '100%' }}>
						<thead>
							<tr>
								<th colSpan={3}>
									<div>
										<h3 className="benefit-information-title">Benefit Information</h3>
									</div>
								</th>
								<th colSpan={1}>&nbsp;</th>
							</tr>
						</thead>
						<tbody className="summaryBody">{this.renderInsuranceBenefits(insurances)}</tbody>
					</table>
				)
			}

			return null
		}
	}

	renderInsuranceBenefits(insurances: IInpatientTypeInsurance[]): React.ReactNode {
		return insurances.map((insurance, index) => {
			return <InsuranceBenefitsComponent key={index} data={insurance} CoverageDiscoveryResponseStateManager={this.props.CoverageDiscoveryResponseStateManager} />
		})
	}
}
